/**
 * libraryCache — Cache IndexedDB para works da Biblioteca (stale-while-revalidate)
 *
 * Usa CacheManager (L1 Memory + L2 IndexedDB) para servir dados
 * instantaneamente do cache e revalidar em background.
 *
 * Padrão idêntico a driveProject/projectCache.ts
 */
import { createBigwaCache } from '../core/cache';
import type { Work } from '../types/work';

// L1: 5 min (session), L2: 24h (IndexedDB, revalida em background)
export const worksCache = createBigwaCache<Work[]>(
  'library-works',
  5 * 60 * 1000,
  24 * 60 * 60 * 1000
);

/**
 * Gera chave de cache isolada por usuário
 */
export function getLibraryCacheKey(): string {
  let userId = 'unknown';
  try {
    const userStr = localStorage.getItem('bigwa_user');
    if (userStr) {
      const user = JSON.parse(userStr);
      userId = user.email || 'unknown';
    }
  } catch { /* ignore */ }
  return `library:${userId}`;
}
